import { CombinedGraphQLErrors } from "@apollo/client/errors";

export function formErrorMessage(error: unknown): string {
  if (CombinedGraphQLErrors.is(error)) {
    return (
      error.errors.map((graphqlError) => graphqlError.message).join(", ") ||
      error.message
    );
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Something went wrong";
}
